var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    { staticClass: "root" },
    [
      _c(
        "w-scroll-view",
        { ref: "scroller" },
        [
          _c("app-column-select-edit-node", {
            attrs: {
              "preview-value": _vm.previewValue,
              model: _vm.model,
              "ignored-paths": _vm.ignoredPaths,
              "filter-text": _vm.filterText.toLowerCase(),
              "is-server-column": _vm.isServerColumn,
              "selected-value": _vm.value,
              "filterable-only": _vm.filterableOnly,
              "full-path": _vm.prefix,
              "nummeric-only": _vm.nummericOnly,
              browse: _vm.browse,
              "ignored-fields": _vm.ignoredFields,
              favourites: _vm.favourites,
              "show-favourites": _vm.showFavourites,
              "is-initial-render": _vm.isInitialRender,
              "can-favourite": _vm.canFavourite,
            },
            on: {
              input: function ($event) {
                return _vm.onInput($event)
              },
              name: function ($event) {
                return _vm.onName($event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }